import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'utcDate',
    standalone: false
})
export class UtcDatePipe implements PipeTransform {
  transform(value: any): any {
    if (!value) {
      return '';
    }

    const date = new Date(value);
    const utcDate = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    );

    return utcDate;
  }
}
